var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1053_17125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5072 15.5366C16.7608 16.0572 15.8938 16.3323 15 16.3323C14.1062 16.3323 13.2393 16.0572 12.4929 15.5366L0.199746 6.96267C0.131543 6.91511 0.0650977 6.86551 0 6.81451V20.8638C0 22.4746 1.24951 23.753 2.7617 23.753H27.2382C28.778 23.753 29.9999 22.4458 29.9999 20.8638V6.81445C29.9347 6.86558 29.8682 6.91529 29.7998 6.96292L17.5072 15.5366Z",
    fill: "#0044EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1748 5.4324L13.4679 14.0064C13.9333 14.331 14.4666 14.4932 14.9999 14.4932C15.5333 14.4932 16.0667 14.3309 16.5321 14.0064L28.8252 5.4324C29.5608 4.91964 30 4.06147 30 3.13525C30 1.54267 28.7615 0.24707 27.2392 0.24707H2.76076C1.2385 0.247132 0 1.54273 0 3.13678C0 4.06147 0.439219 4.91964 1.1748 5.4324Z",
    fill: "#0044EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1053_17125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail3);
export default __webpack_public_path__ + "static/media/icon_mail_3.9f15e31188704d1f2bedacbe6dd4f959.svg";
export { ForwardRef as ReactComponent };